
import React from 'react';
import { Col, Row, Image } from "react-bootstrap";
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { KeyboardArrowDown as KeyboardArrowDownIcon } from '@mui/icons-material';
import FAQData from './FaqData';

import './FAQ.scss';

function buildList(list, index) {
  return (
    <ul key={index}>
      {list.map((listItem, i) => Array.isArray(listItem) ?
        buildList(listItem, i) :
        <li key={i}>{listItem}</li>
      )}
    </ul>
  );
}

function FAQCard(props) {
  return (
    <Row>
      <Accordion className={(props.isTermInsuranceProduct || props.isFinalExpenseProduct || props.isWholeLifeProduct || props.isUniversalLifeProduct || props.isLoanProtectionProduct || props.isBusinessSolutions) ?`accordion panel-ans px-0`:`accordion px-0 accordion-top-border`}>
        <AccordionSummary
          expandIcon={<KeyboardArrowDownIcon />}
          aria-controls="panel1-content"
          id={props.index}
          className='term-exp py-2 px-0'
          role=''
        >
          <span className= {(props.isTermInsuranceProduct || props.isFinalExpenseProduct || props.isWholeLifeProduct || props.isUniversalLifeProduct || props.isLoanProtectionProduc || props.isBusinessSolutions) ?"term-FAQuestion":"question"}>{props.question}</span>
        </AccordionSummary>
        <AccordionDetails className={props.isTermInsuranceProduct?'px-0 pt-0':'pb-3 px-0 pt-0'}>
        <div className='FAQ-ans'>
            {props.answer.map((paragraph, i) => Array.isArray(paragraph) ?
              buildList(paragraph, i)
              : <p key={i} dangerouslySetInnerHTML={{ __html: paragraph }}></p>)}
          </div>
        </AccordionDetails>
      </Accordion>
    </Row>
  )
}

export default function FAQs(props) {
  let faqData = [];
  if (props.isAddDefaultFaq === false) {
    faqData = props.data
  }
  else if ((props.isPermProduct || props.isJuviProduct)) {
    faqData = props.data.concat(FAQData()
    .filter((data) => data.title !== "How much coverage should I purchase?" && data.isCommonFaq !== true)); // Remove this default question from the perm product (#7258)
  }
  else {
    faqData = props.data.concat(FAQData().filter((data) => data.isCommonFaq !== true));
  }
  if(!props.hideCommonFaq){
    faqData = faqData.concat(FAQData()
    .filter((data) => data.isCommonFaq === true));
  }

  return (
    <div className="faq-section">
      <Row className={(props.isTermInsuranceProduct || props.isFinalExpenseProduct || props.isWholeLifeProduct || props.isUniversalLifeProduct || props.isLoanProtectionProduct || props.isBusinessSolutions) ? `customizeterm-faq justify-content-center light-background`:"circle-section justify-content-center grey-section"}>
        {(!props.isTermInsuranceProduct && !props.isFinalExpenseProduct && !props.isWholeLifeProduct && !props.isUniversalLifeProduct && !props.isLoanProtectionProduct && !props.isBusinessSolutions) && <Image src="./circle.png" className="circle-1 position-absolute px-0" alt="" />}
        <Col className="content-section">
          <Row className="mx-3 mb-4 justify-content-center">
            <h2 className='FAQ-term text-center'>Frequently Asked Questions</h2>
          </Row>
          {faqData.map((faq, index) => <FAQCard title={props.title} 
            isTermInsuranceProduct={props.isTermInsuranceProduct} 
            isFinalExpenseProduct={props.isFinalExpenseProduct} 
            isWholeLifeProduct={props.isWholeLifeProduct} 
            isUniversalLifeProduct={props.isUniversalLifeProduct} 
            isBusinessSolutions={props.isBusinessSolutions}
            isLoanProtectionProduct={props.isLoanProtectionProduct} key={index} index={index} question={faq.title} answer={faq.text} />)}
        </Col>
        {(!props.isTermInsuranceProduct && !props.isFinalExpenseProduct && !props.isWholeLifeProduct && !props.isUniversalLifeProduct && !props.isLoanProtectionProduct && !props.isBusinessSolutions) && <div className="mt-auto position-relative px-0">
          <Image src="./circle.png" className="circle-2 position-absolute" alt="" />
        </div>}
      </Row>
    </div>
  );
}
